// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overlay_mpHwP {
  z-index: 999;
  position: absolute;
}
.bg_sDiws {
  position: fixed;
  height: 100vh;
  width: 100vw;
  background-color: var(--_00000020-background);
  top: 0;
  left: 0;
}
.addTaxContainer_vp4sv {
  overflow: hidden;
  width: 100%;
  max-width: 550px;
  box-sizing: border-box;
  border-radius: 8px;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  -ms-border-radius: 8px;
  -o-border-radius: 8px;
  position: fixed;
  top: 50%;
  left: 50%;
  background-color: var(--white-color);
  transform: translate(-50%, -50%);
  transform: translate(-50%, -50%) scale(1);
  -webkit-transform: translate(-50%, -50%) scale(1);
  -moz-transform: translate(-50%, -50%) scale(1);
  -ms-transform: translate(-50%, -50%) scale(1);
  -o-transform: translate(-50%, -50%) scale(1);
  animation: scaleUp_H1Lu7 300ms ease-out forwards;
  @media (width<768px) {
    height: 100vh;
    width: 100vw;
    max-width: 100vw;
  }
}

.addTaxContent_o1Mim {
  padding: 20px;
  input[type="checkbox"] {
    accent-color: var(--_10a37f-background);
  }
  .taxes_lSg4E {
    display: flex;
    align-items: end;
    justify-content: space-between;
    gap: 10px;
    > div {
      width: 100%;
    }
    input {
      background-color: var(--f5-background);
      border: none;
      outline: none;
      padding: 8px 10px;
      box-sizing: border-box;
      color: var(--black-color);
    }
    .compuesto_NOPmm {
      display: flex;
      align-items: center;
      gap: 10px;
    }
  }
  table {
    border-collapse: collapse; 
  }
  table thead {
    font-size: 13px;
  }

  .small_DBdR4 {
    min-width: 10px;
  }
  .selectedRow_efDDQ {
    background-color: var(--eeeeef-background);
  }
  .tableTaxes_L5bMz {
    border-bottom: 1px solid var(--e3-border);
    padding-bottom: 30px;
    button {
      background-color: transparent;
      border: none;
      outline: none;
      text-decoration: underline;
      font-weight: 700;
      margin-top: 10px;
      cursor: pointer;
    }
  }


}

.scaleDown_s7YTw {
  animation: scaleDown_s7YTw 300ms ease-in forwards;
  -webkit-animation: scaleDown_s7YTw 300ms ease-in forwards;
}

@keyframes scaleUp_H1Lu7 {
  from {
    transform: translate(-50%, -50%) scale(0);
    -webkit-transform: translate(-50%, -50%) scale(0);
    -moz-transform: translate(-50%, -50%) scale(0);
    -ms-transform: translate(-50%, -50%) scale(0);
    -o-transform: translate(-50%, -50%) scale(0);
  }
  to {
    transform: translate(-50%, -50%) scale(1);
    -webkit-transform: translate(-50%, -50%) scale(1);
    -moz-transform: translate(-50%, -50%) scale(1);
    -ms-transform: translate(-50%, -50%) scale(1);
    -o-transform: translate(-50%, -50%) scale(1);
  }
}

@keyframes scaleDown_s7YTw {
  from {
    transform: translate(-50%, -50%) scale(1);
  }
  to {
    transform: translate(-50%, -50%) scale(0);
    -webkit-transform: translate(-50%, -50%) scale(0);
    -moz-transform: translate(-50%, -50%) scale(0);
    -ms-transform: translate(-50%, -50%) scale(0);
    -o-transform: translate(-50%, -50%) scale(0);
  }
}

.fadeOut_iRbi9 {
  opacity: 0;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/AddTax/AddTax.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,aAAa;EACb,YAAY;EACZ,6CAA6C;EAC7C,MAAM;EACN,OAAO;AACT;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,gCAAgC;EAKhC,yCAAyC;EACzC,iDAAiD;EACjD,8CAA8C;EAC9C,6CAA6C;EAC7C,4CAA4C;EAC5C,gDAA0C;EAC1C;IACE,aAAa;IACb,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb;IACE,uCAAuC;EACzC;EACA;IACE,aAAa;IACb,gBAAgB;IAChB,8BAA8B;IAC9B,SAAS;IACT;MACE,WAAW;IACb;IACA;MACE,sCAAsC;MACtC,YAAY;MACZ,aAAa;MACb,iBAAiB;MACjB,sBAAsB;MACtB,yBAAyB;IAC3B;IACA;MACE,aAAa;MACb,mBAAmB;MACnB,SAAS;IACX;EACF;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,yCAAyC;IACzC,oBAAoB;IACpB;MACE,6BAA6B;MAC7B,YAAY;MACZ,aAAa;MACb,0BAA0B;MAC1B,gBAAgB;MAChB,gBAAgB;MAChB,eAAe;IACjB;EACF;;;AAGF;;AAEA;EACE,iDAA2C;EAC3C,yDAAmD;AACrD;;AAEA;EACE;IACE,yCAAyC;IACzC,iDAAiD;IACjD,8CAA8C;IAC9C,6CAA6C;IAC7C,4CAA4C;EAC9C;EACA;IACE,yCAAyC;IACzC,iDAAiD;IACjD,8CAA8C;IAC9C,6CAA6C;IAC7C,4CAA4C;EAC9C;AACF;;AAEA;EACE;IACE,yCAAyC;EAC3C;EACA;IACE,yCAAyC;IACzC,iDAAiD;IACjD,8CAA8C;IAC9C,6CAA6C;IAC7C,4CAA4C;EAC9C;AACF;;AAEA;EACE,UAAU;AACZ","sourcesContent":[".overlay {\n  z-index: 999;\n  position: absolute;\n}\n.bg {\n  position: fixed;\n  height: 100vh;\n  width: 100vw;\n  background-color: var(--_00000020-background);\n  top: 0;\n  left: 0;\n}\n.addTaxContainer {\n  overflow: hidden;\n  width: 100%;\n  max-width: 550px;\n  box-sizing: border-box;\n  border-radius: 8px;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  background-color: var(--white-color);\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%) scale(1);\n  -webkit-transform: translate(-50%, -50%) scale(1);\n  -moz-transform: translate(-50%, -50%) scale(1);\n  -ms-transform: translate(-50%, -50%) scale(1);\n  -o-transform: translate(-50%, -50%) scale(1);\n  animation: scaleUp 300ms ease-out forwards;\n  @media (width<768px) {\n    height: 100vh;\n    width: 100vw;\n    max-width: 100vw;\n  }\n}\n\n.addTaxContent {\n  padding: 20px;\n  input[type=\"checkbox\"] {\n    accent-color: var(--_10a37f-background);\n  }\n  .taxes {\n    display: flex;\n    align-items: end;\n    justify-content: space-between;\n    gap: 10px;\n    > div {\n      width: 100%;\n    }\n    input {\n      background-color: var(--f5-background);\n      border: none;\n      outline: none;\n      padding: 8px 10px;\n      box-sizing: border-box;\n      color: var(--black-color);\n    }\n    .compuesto {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n    }\n  }\n  table {\n    border-collapse: collapse; \n  }\n  table thead {\n    font-size: 13px;\n  }\n\n  .small {\n    min-width: 10px;\n  }\n  .selectedRow {\n    background-color: var(--eeeeef-background);\n  }\n  .tableTaxes {\n    border-bottom: 1px solid var(--e3-border);\n    padding-bottom: 30px;\n    button {\n      background-color: transparent;\n      border: none;\n      outline: none;\n      text-decoration: underline;\n      font-weight: 700;\n      margin-top: 10px;\n      cursor: pointer;\n    }\n  }\n\n\n}\n\n.scaleDown {\n  animation: scaleDown 300ms ease-in forwards;\n  -webkit-animation: scaleDown 300ms ease-in forwards;\n}\n\n@keyframes scaleUp {\n  from {\n    transform: translate(-50%, -50%) scale(0);\n    -webkit-transform: translate(-50%, -50%) scale(0);\n    -moz-transform: translate(-50%, -50%) scale(0);\n    -ms-transform: translate(-50%, -50%) scale(0);\n    -o-transform: translate(-50%, -50%) scale(0);\n  }\n  to {\n    transform: translate(-50%, -50%) scale(1);\n    -webkit-transform: translate(-50%, -50%) scale(1);\n    -moz-transform: translate(-50%, -50%) scale(1);\n    -ms-transform: translate(-50%, -50%) scale(1);\n    -o-transform: translate(-50%, -50%) scale(1);\n  }\n}\n\n@keyframes scaleDown {\n  from {\n    transform: translate(-50%, -50%) scale(1);\n  }\n  to {\n    transform: translate(-50%, -50%) scale(0);\n    -webkit-transform: translate(-50%, -50%) scale(0);\n    -moz-transform: translate(-50%, -50%) scale(0);\n    -ms-transform: translate(-50%, -50%) scale(0);\n    -o-transform: translate(-50%, -50%) scale(0);\n  }\n}\n\n.fadeOut {\n  opacity: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `overlay_mpHwP`,
	"bg": `bg_sDiws`,
	"addTaxContainer": `addTaxContainer_vp4sv`,
	"scaleUp": `scaleUp_H1Lu7`,
	"addTaxContent": `addTaxContent_o1Mim`,
	"taxes": `taxes_lSg4E`,
	"compuesto": `compuesto_NOPmm`,
	"small": `small_DBdR4`,
	"selectedRow": `selectedRow_efDDQ`,
	"tableTaxes": `tableTaxes_L5bMz`,
	"scaleDown": `scaleDown_s7YTw`,
	"fadeOut": `fadeOut_iRbi9`
};
export default ___CSS_LOADER_EXPORT___;
